import { Button, Table } from "react-bootstrap";
import { SearchableDropdown } from "../Pages/BillingInformation";
import { Trash } from "react-feather";
import { formatDate } from "../config/function";
import {
  useState,
  useRef,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";

const BillingInformationList = ({
  rateType,
  billingTrip,
  handleInputChange,
  sources,
  fixSources,
  destinations,
  fixDestinations,
  handleDelete,
  selectedVehicle,
  handleVehicleChange,
  filteredVehicles,
}) => {
  const [error, setError] = useState({});

  const totalAmount = billingTrip.reduce(
    (sum, t) => sum + (parseFloat(t.amount) || 0),
    0,
  );
  const totalWeighment = billingTrip.reduce(
    (sum, t) => sum + (parseFloat(t.transition_charge) || 0),
    0,
  );
  const totalAdvance = billingTrip.reduce(
    (sum, t) => sum + (parseFloat(t.advance_amount) || 0),
    0,
  );
  const totalBalance = billingTrip.reduce(
    (sum, t) => sum + (parseFloat(t.balance_amount) || 0),
    0,
  );

  const sourceRef = useRef([]);
  const destRef = useRef([]);
  const tonesRef = useRef([]);
  const amountRef = useRef([]);
  const weighRef = useRef([]);
  const advanceRef = useRef([]);
  const balanceRef = useRef([]);
  const remarkRef = useRef([]);
  const dateRef = useRef([]);
  const vehicleRef = useRef([]);

  const fieldStyle = {
    width: "90px",
    border: "none",
    borderBottom: "none",
    outline: "none",
    background: "transparent",
    marginBottom: "0",
  };
  const labelStyle = { margin: 0 };
  const alignStyle = { display: "flex", alignItems: "center", gap: "8px" };

  const handleEnter = (e, nextRef, index) => {
    if (e.key === "Enter") {
      e.preventDefault();

      if (nextRef === "nextRow") {
        vehicleRef.current[index + 1]?.focus();
        return;
      }

      nextRef.current[index]?.focus();
    }
  };

  return (
    <>
    <div
        style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Table
          style={{
            width: "58%",
            textAlign: "center",
            background: "#fff",
          }}
        >
          <thead>
            <tr style={{ background: "#e9ecef", fontWeight: "bold" }}>
              <th style={{ width: "22%", textAlign: "center" }}>Amount</th>
              <th style={{ width: "22%", textAlign: "center" }}>Weighment</th>
              <th style={{ width: "22%", textAlign: "center" }}>Advance</th>
              <th style={{ width: "22%", textAlign: "center" }}>Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ fontWeight: "bold" }}>
              <td style={{ textAlign: "center" }}>{totalAmount.toFixed(2)}</td>
              <td style={{ textAlign: "center" }}>
                {totalWeighment.toFixed(2)}
              </td>
              <td style={{ textAlign: "center" }}>{totalAdvance.toFixed(2)}</td>
              <td style={{ textAlign: "center" }}>{totalBalance.toFixed(2)}</td>
            </tr>
          </tbody>
        </Table>
      </div>
      <Table>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Vehicle</th>
            <th>Trip Date</th>
            <th>Source</th>
            <th>Destination</th>
            {rateType === "km" && (
              <>
                <th>Total Tones</th>
                <th>Weighment Charge</th>
                <th>Advance Amount</th>
                <th>Balance Amount</th>
                <th>Remark</th>
              </>
            )}
            {rateType === "fixed" && (
              <>
                <th>Amount</th>
                <th>Weighment Charge</th>
                <th>Advance Amount</th>
                <th>Balance Amount</th>
                <th>Remark</th>
              </>
            )}
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {billingTrip.map((t, i) => {
            return (
              <tr key={i}>
                <td>{i + 1}</td>
                <td style={{ verticalAlign: "top" }}>
                  <div style={{ marginTop: "3px" }}>
                    <SearchableDropdown
                      value={t.vehicle_number || ""}
                      onChange={(obj) => handleInputChange(i, "vehicle", obj)}
                      allowManual={false}
                      options={filteredVehicles?.map((v) => ({
                        id: v.id,
                        title: v.vehicle_number,
                        vendor_id: v.vendor_id,
                      }))}
                      ref={(el) => (vehicleRef.current[i] = el)}
                      onKeyDown={(e) => handleEnter(e, dateRef, i)}
                      rateType={rateType}
                      customStyle={{ marginTop: "-20px" }}
                    />
                  </div>
                </td>

                <td>
                  <input
                    type="date"
                    value={t.date}
                    onChange={(e) =>
                      handleInputChange(i, "date", e.target.value)
                    }
                    style={{ marginBottom: rateType === "km" ? "22px" : "" }}
                    ref={(el) => (dateRef.current[i] = el)}
                    onKeyDown={(e) => handleEnter(e, sourceRef, i)}
                  />
                </td>
                <td>
                  <SearchableDropdown
                    value={t.source_name || ""}
                    onChange={(obj) =>
                      handleInputChange(
                        i,
                        "source_name",
                        obj?.title || "",
                        obj?.id ? false : true,
                      )
                    }
                    options={rateType === "km" ? sources : fixSources}
                    allowManual={rateType === "fixed"}
                    ref={(el) => (sourceRef.current[i] = el)}
                    onKeyDown={(e) => handleEnter(e, destRef, i)}
                  />
                  {rateType === "km" && (
                    <div style={alignStyle}>
                      <label style={labelStyle}>Rate:</label>
                      <input
                        type="number"
                        value={t.rate || 0}
                        readOnly
                        style={fieldStyle}
                      />
                    </div>
                  )}
                </td>

                <td>
                  <SearchableDropdown
                    value={t.destination_name || ""}
                    onChange={(obj) =>
                      handleInputChange(
                        i,
                        "destination_name",
                        obj?.title || "",
                        obj?.id ? false : true,
                      )
                    }
                    options={rateType === "km" ? destinations : fixDestinations}
                    allowManual={rateType === "fixed"}
                    ref={(el) => (destRef.current[i] = el)}
                    onKeyDown={(e) => {
                      if (rateType === "km") handleEnter(e, tonesRef, i);
                      else handleEnter(e, amountRef, i);
                    }}
                  />
                  {rateType === "km" && (
                    <div style={alignStyle}>
                      <label style={labelStyle}>km:</label>
                      <input
                        type="number"
                        value={t.total_km}
                        readOnly
                        style={fieldStyle}
                      />
                    </div>
                  )}
                </td>

                {rateType === "km" && (
                  <>
                    <td>
                      <input
                        type="number"
                        min={1}
                        max={140}
                        value={t.total_tones}
                        onChange={(e) => {
                          const value = Number(e.target.value);

                          handleInputChange(i, "total_tones", value);

                          setError((prev) => ({
                            ...prev,
                            [i]:
                              value < 1 || value > 140
                                ? "Tones must be between 1 and 40"
                                : "",
                          }));
                        }}
                        onWheel={(e) => e.target.blur()}
                        onFocus={() => {
                          if (t.total_tones === 0) {
                            handleInputChange(i, "total_tones", "");
                          }
                        }}
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        ref={(el) => (tonesRef.current[i] = el)}
                        onKeyDown={(e) => handleEnter(e, weighRef, i)}
                        style={{ width: "97px" }}
                      />
                      {error[i] && (
                        <div style={{ color: "red", fontSize: "11px" }}>
                          {error[i]}
                        </div>
                      )}
                      <div style={alignStyle}>
                        <label style={labelStyle}>Amt</label>
                        <input
                          type="number"
                          value={Number(t.amount.toFixed(2))}
                          readOnly
                          style={fieldStyle}
                        />
                      </div>
                    </td>

                    <td>
                      <input
                        type="number"
                        min={0}
                        value={t.transition_charge}
                        onChange={(e) =>
                          handleInputChange(
                            i,
                            "transition_charge",
                            e.target.value,
                          )
                        }
                        onWheel={(e) => e.target.blur()}
                        onFocus={() => {
                          if (t.transition_charge === 0) {
                            handleInputChange(i, "transition_charge", "");
                          }
                        }}
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        ref={(el) => (weighRef.current[i] = el)}
                        onKeyDown={(e) => handleEnter(e, advanceRef, i)}
                        style={{ width: "97px", marginBottom: "22px" }}
                      />
                    </td>
                    <td>
                      {t.advance_list?.length > 1 ? (
                        <AdvanceTableDropdown
                          advanceList={t.advance_list?.filter(
                            (a) =>
                              !billingTrip.some(
                                (row, idx) =>
                                  idx !== i && row.advance_id === a.id,
                              ),
                          )}
                          value={t.advance_id || ""}
                          onChange={(selected) => {
                            handleInputChange(
                              i,
                              "advance_amount",
                              selected?.amount || 0,
                            );
                            handleInputChange(
                              i,
                              "advance_id",
                              selected?.id || null,
                            );
                          }}
                          rateType={rateType}
                          ref={(el) => (advanceRef.current[i] = el)}
                          onKeyDown={(e) => handleEnter(e, balanceRef, i)}
                        />
                      ) : (
                        <input
                          type="number"
                          value={t.advance_amount}
                          readOnly
                          style={{ width: "97px", marginBottom: "22px" }}
                          onWheel={(e) => e.target.blur()}
                          onFocus={(e) => {
                            if (e.target.value === "0") e.target.value = "";
                          }}
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          ref={(el) => (advanceRef.current[i] = el)}
                          onKeyDown={(e) => handleEnter(e, balanceRef, i)}
                        />
                      )}
                    </td>
                  </>
                )}

                {rateType === "fixed" && (
                  <>
                    <td>
                      <input
                        type="number"
                        min={0}
                        value={t.amount}
                        onChange={(e) =>
                          handleInputChange(i, "amount", e.target.value)
                        }
                        onWheel={(e) => e.target.blur()}
                        onFocus={(e) => {
                          if (e.target.value === "0") e.target.value = "";
                        }}
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        ref={(el) => (amountRef.current[i] = el)}
                        onKeyDown={(e) => handleEnter(e, weighRef, i)}
                        style={{ width: "97px" }}
                      />
                    </td>

                    <td>
                      <input
                        type="number"
                        min={0}
                        value={t.transition_charge}
                        onChange={(e) =>
                          handleInputChange(
                            i,
                            "transition_charge",
                            e.target.value,
                          )
                        }
                        onWheel={(e) => e.target.blur()}
                        onFocus={(e) => {
                          if (e.target.value === "0") e.target.value = "";
                        }}
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        ref={(el) => (weighRef.current[i] = el)}
                        onKeyDown={(e) => handleEnter(e, advanceRef, i)}
                        style={{ width: "97px" }}
                      />
                    </td>

                    <td>
                      {t.advance_list?.length > 1 ? (
                        <AdvanceTableDropdown
                          advanceList={t.advance_list}
                          value={t.advance_id || ""}
                          onChange={(selected) => {
                            handleInputChange(
                              i,
                              "advance_amount",
                              selected?.amount || 0,
                            );
                            handleInputChange(
                              i,
                              "advance_id",
                              selected?.id || null,
                            );
                          }}
                          onWheel={(e) => e.target.blur()}
                          onFocus={(e) => {
                            if (e.target.value === "0") e.target.value = "";
                          }}
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          ref={(el) => (advanceRef.current[i] = el)}
                          onKeyDown={(e) => handleEnter(e, balanceRef, i)}
                        />
                      ) : (
                        <input
                          type="number"
                          value={t.advance_amount}
                          readOnly
                          style={{ width: "97px" }}
                          onWheel={(e) => e.target.blur()}
                          onFocus={(e) => {
                            if (e.target.value === "0") e.target.value = "";
                          }}
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          ref={(el) => (advanceRef.current[i] = el)}
                          onKeyDown={(e) => handleEnter(e, balanceRef, i)}
                        />
                      )}
                    </td>
                  </>
                )}

                <td>
                  <input
                    type="number"
                    value={t.balance_amount.toFixed(2)}
                    readOnly
                    ref={(el) => (balanceRef.current[i] = el)}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-"].includes(e.key)) {
                        e.preventDefault();
                      }

                      handleEnter(e, remarkRef, i);
                    }}
                    style={{
                      width: "97px",
                      marginBottom: rateType === "km" ? "22px" : "",
                    }}
                  />
                </td>

                <td>
                  <input
                    type="text"
                    value={t.remarks}
                    onChange={(e) =>
                      handleInputChange(i, "remarks", e.target.value)
                    }
                    ref={(el) => (remarkRef.current[i] = el)}
                    onKeyDown={(e) => handleEnter(e, "nextRow", i)}
                    style={{
                      width: "95px",
                      marginBottom: rateType === "km" ? "22px" : "",
                    }}
                  />
                </td>

                <td>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDelete(i)}
                  >
                    <Trash size={14} />
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Table
          style={{
            width: "58%",
            textAlign: "center",
            background: "#fff",
          }}
        >
          <thead>
            <tr style={{ background: "#e9ecef", fontWeight: "bold" }}>
              <th style={{ width: "22%", textAlign: "center" }}>Amount</th>
              <th style={{ width: "22%", textAlign: "center" }}>Weighment</th>
              <th style={{ width: "22%", textAlign: "center" }}>Advance</th>
              <th style={{ width: "22%", textAlign: "center" }}>Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ fontWeight: "bold" }}>
              <td style={{ textAlign: "center" }}>{totalAmount.toFixed(2)}</td>
              <td style={{ textAlign: "center" }}>
                {totalWeighment.toFixed(2)}
              </td>
              <td style={{ textAlign: "center" }}>{totalAdvance.toFixed(2)}</td>
              <td style={{ textAlign: "center" }}>{totalBalance.toFixed(2)}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default BillingInformationList;

const AdvanceTableDropdown = forwardRef(
  ({ advanceList, value, onChange, rateType, onKeyDown }, ref) => {
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef(null);

    const selected = advanceList.find((a) => a.id == value);

    useImperativeHandle(ref, () => ({
      focus: () => {
        wrapperRef.current?.focus();
        setOpen(true);
      },
    }));
    useEffect(() => {
      const handleClickOutside = (e) => {
        if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
          setOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    const sortedAdvanceList = [...advanceList].sort(
      (a, b) => new Date(a.date) - new Date(b.date),
    );
    return (
      <div
        ref={wrapperRef}
        tabIndex={0}
        style={{ position: "relative", width: "160px" }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onKeyDown && onKeyDown(e);
          }
        }}
      >
        <div
          onClick={() => setOpen((prev) => !prev)}
          style={{
            border: "1px solid #ced4da",
            borderRadius: "4px",
            padding: "4px 8px",
            cursor: "pointer",
            background: "#fff",
            fontSize: "13px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            minHeight: "31px",
            marginBottom: rateType === "km" ? "20px" : "",
          }}
        >
          <span>{selected ? `₹${selected.amount}` : "Select Advance"}</span>
          <span style={{ fontSize: "10px", color: "#666" }}>▼</span>
        </div>

        {/* Dropdown Table */}
        {open && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              zIndex: 999,
              background: "#fff",
              border: "1px solid #ced4da",
              borderRadius: "4px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              minWidth: "220px",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "12px",
              }}
            >
              <thead>
                <tr style={{ background: "#e9ecef" }}>
                  <th
                    style={{
                      padding: "5px 8px",
                      borderBottom: "1px solid #dee2e6",
                      textAlign: "right",
                    }}
                  >
                    Amount
                  </th>
                  <th
                    style={{
                      padding: "5px 8px",
                      borderBottom: "1px solid #dee2e6",
                      textAlign: "center",
                    }}
                  >
                    Date
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedAdvanceList.map((a) => (
                  <tr
                    key={a.id}
                    onMouseDown={() => {
                      onChange(a);
                      setOpen(false);
                    }}
                    style={{
                      cursor: "pointer",
                      background: value == a.id ? "#cfe2ff" : "white",
                      transition: "background 0.15s",
                    }}
                    onMouseEnter={(e) => {
                      if (value != a.id)
                        e.currentTarget.style.background = "#f0f4ff";
                    }}
                    onMouseLeave={(e) => {
                      if (value != a.id)
                        e.currentTarget.style.background = "white";
                    }}
                  >
                    <td
                      style={{
                        padding: "5px 8px",
                        textAlign: "right",
                        borderBottom: "1px solid #f0f0f0",
                      }}
                    >
                      ₹{a.amount}
                    </td>
                    <td
                      style={{
                        padding: "5px 8px",
                        textAlign: "center",
                        borderBottom: "1px solid #f0f0f0",
                        color: "#555",
                      }}
                    >
                      {formatDate(a.date)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  },
);
